// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/dist/vuetify.min.css
// module id = 1429
// module chunks = 50